import { api } from 'src/utils/api';
import moment from 'moment';

const loadDealsRequest = (params = {}) => api.get('/deal', { params });

const loadDealRequest = id => api.get(`/deal/${id}`);

const createDealRequest = ({
    pkDebt,
    amount,
    installments = [],
    paymentInstallments = 1,
    due = moment().add(2, 'days').format('YYYY-MM-DD'),
    action = null,
    fkChargeType = 1,
    fkOperator = null,
    operatorComission = null,
    text,
    ...rest
}) => api.post('/deal', {
    pk_debt: pkDebt,
    amount,
    installments,
    payment_installments: paymentInstallments,
    due,
    action,
    fk_charge_type: fkChargeType,
    fk_operator: fkOperator,
    fk_operator_comission: operatorComission,
    text,
    ...rest
});

const processManualPayment = (params) => api.post('/deal/process-manual-payment',{
    charges: params.charges,
    fkPaymentType: params.fkPaymentType,
    text: params.text,
    fkDebt: params.fkDebt 
});


export {
    loadDealsRequest,
    loadDealRequest,
    createDealRequest,
    processManualPayment
};
